import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { Body3 } from '../../../../../../atomic/text/Text';

export const Symbol = ({ alert }) => {
  return (
    <td>
      <Body3 color={colors.lightGrey} fontWeight={500}>
        {alert.symbol}
      </Body3>
    </td>
  );
};

Symbol.propTypes = {
  alert: PropTypes.shape({
    symbol: PropTypes.any,
  }),
};
